import { AuthStorage, localStorageHelper, PluggableStorage } from '@frontend/auth-helpers';

export const ssoCallbackStore = PluggableStorage.create('sso-callback', sessionStorage);

export const getRememberedSsoTenant = () => localStorageHelper.get<string>(AuthStorage.remembered_sso_tenant);

export const rememberSsoTenant = (tenant: string | undefined) => {
  tenant && localStorageHelper.create(AuthStorage.remembered_sso_tenant, tenant);
};

export const clearRememberedSsoTenant = () => {
  localStorageHelper.delete(AuthStorage.remembered_sso_tenant);
  ssoCallbackStore.removeItem(AuthStorage.sso_tenant);
};
